import { CategoriesCompanyEnum } from '@types';

export function getCategoryLocale(category: string) {
  return `company.category.${category}`;
}

export function getCategoryOptions(i18n: { t: (key: string) => string}) {
  return Object.values(CategoriesCompanyEnum).map(id => ({ id, label: i18n.t(getCategoryLocale(id)) }));
}
